import { render, staticRenderFns } from "./VStatsBox.vue?vue&type=template&id=5f5833be&scoped=true"
import script from "./VStatsBox.vue?vue&type=script&lang=js"
export * from "./VStatsBox.vue?vue&type=script&lang=js"
import style0 from "./VStatsBox.vue?vue&type=style&index=0&id=5f5833be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5833be",
  null
  
)

export default component.exports